import { get } from 'lodash';
import { getTimeInSeconds } from 'lib/time';

/**
 * @param {Object} params
 * @param {String} params.provider
 * @return {Promise<Array<Asset>>}
 */
export async function fetchLiveAssets({ provider, assetType = 'video' }) {
    const query = {
        filter: `streamType::live|status::active,readyToPublish,draft|assetType::${assetType}`,
        limit: 100,
        sort: '-flightTimes.start',
        showAll: true,
        cb: Math.random(),
    };
    const result = await this.get('v1/svp/{PROVIDER}/search', { provider, query });
    return get(result, '_embedded.assets');
}

export async function fetchWasLiveAssets({ provider, assetType = 'video' }) {
    const last24hours = getTimeInSeconds() - 24 * 3600;

    const query = {
        filter: `streamType::wasLive|status::active|assetType::${assetType}`,
        sort: 'created',
        after: last24hours,
        showAll: true,
        cb: Math.random(),
    };
    const result = await this.get('v1/svp/{PROVIDER}/assets', { provider, query });
    return get(result, '_embedded.assets');
}
